export default __webpack_public_path__ + "static/media/Ostali 5.88f74329.jpg";